var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchCircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5052_6519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.34 18.26L18.26 15.18C19.25 13.64 19.8 11.88 19.8 9.9C19.8 4.4 15.4 0 9.9 0C4.4 0 0 4.4 0 9.9C0 15.4 4.4 19.8 9.9 19.8C11.88 19.8 13.64 19.25 15.18 18.26L18.26 21.34C19.14 22.22 20.46 22.22 21.34 21.34C22.22 20.46 22.22 19.14 21.34 18.26ZM9.9 17.6C5.61 17.6 2.2 14.19 2.2 9.9C2.2 5.61 5.61 2.2 9.9 2.2C14.19 2.2 17.6 5.61 17.6 9.9C17.6 14.19 14.19 17.6 9.9 17.6Z",
    fill: "#1D75C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4999 11C4.8399 11 4.3999 10.56 4.3999 9.90002C4.3999 6.82002 6.8199 4.40002 9.8999 4.40002C10.5599 4.40002 10.9999 4.84002 10.9999 5.50002C10.9999 6.16002 10.5599 6.60002 9.8999 6.60002C8.0299 6.60002 6.5999 8.03002 6.5999 9.90002C6.5999 10.56 6.1599 11 5.4999 11Z",
    fill: "#1D75C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5052_6519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCircleIcon);
export default __webpack_public_path__ + "static/media/searchCircleIcon.939ab334da1c8d6bd0bf1303a2fa0a43.svg";
export { ForwardRef as ReactComponent };